import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let levelName = "";
  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, DATA DASAR PENDUDUK</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tahun
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.periode?.year}
          </th>
        </tr>
        {reportInfo?.statusPeriode === "monthly" && (
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Bulan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
            </th>
          </tr>
        )}
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: "center", width: "80px" }}>No</th>
            {(currentLevel === UserLevel.National.toLowerCase() ||
              currentLevel === UserLevel.Province.toLowerCase()) && (
                <>
                  <th>Provinsi</th>
                  <th>Kabupaten/Kota</th>
                </>
              )}
            {currentLevel === UserLevel.District.toLowerCase() && (
              <th>Fasyankes</th>
            )}
            {(currentLevel === UserLevel.Fasyankes.toLowerCase() ||
              currentLevel === UserLevel.District.toLowerCase()) && (
                <th>Desa</th>
              )}
            <th>Jumlah Penduduk</th>
            {(currentLevel === UserLevel.National.toLowerCase() ||
              currentLevel === UserLevel.Province.toLowerCase()) && (
              <th>Endemisitas Tahun Sebelumnya</th>
            )}
          </tr>
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td style={{ width: "80px" }}>{index + 1}</td>
                {(currentLevel === UserLevel.National.toLowerCase() ||
                  currentLevel === UserLevel.Province.toLowerCase()) && (
                    <>
                      <td>{item?.province}</td>
                      <td>{item?.district}</td>
                    </>
                  )}
                {currentLevel === UserLevel.District.toLowerCase() && (
                  <td>{item?.fasyankes}</td>
                )}
                {(currentLevel === UserLevel.Fasyankes.toLowerCase() ||
                  currentLevel === UserLevel.District.toLowerCase()) && (
                    <td>{item?.urbanvillage}</td>
                  )}
                <td>{item?.total_population}</td>
                {(currentLevel === UserLevel.National.toLowerCase() ||
                  currentLevel === UserLevel.Province.toLowerCase()) && (
                  <td>{item?.endemisitas_year_before}</td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
